// frontend/src/constants/returnConstants.js

export const RETURN_LIST_REQUEST = "RETURN_LIST_REQUEST";
export const RETURN_LIST_SUCCESS = "RETURN_LIST_SUCCESS";
export const RETURN_LIST_FAIL = "RETURN_LIST_FAIL";
export const RETURN_LIST_RESET = "RETURN_LIST_RESET";

export const RETURN_ELIGIBILITY_REQUEST = "RETURN_ELIGIBILITY_REQUEST";
export const RETURN_ELIGIBILITY_SUCCESS = "RETURN_ELIGIBILITY_SUCCESS";
export const RETURN_ELIGIBILITY_FAIL = "RETURN_ELIGIBILITY_FAIL";
export const RETURN_ELIGIBILITY_RESET = "RETURN_ELIGIBILITY_RESET";

export const RETURN_CREATE_REQUEST = "RETURN_CREATE_REQUEST";
export const RETURN_CREATE_SUCCESS = "RETURN_CREATE_SUCCESS";
export const RETURN_CREATE_FAIL = "RETURN_CREATE_FAIL";
export const RETURN_CREATE_RESET = "RETURN_CREATE_RESET";

export const RETURN_DETAILS_REQUEST = "RETURN_DETAILS_REQUEST";
export const RETURN_DETAILS_SUCCESS = "RETURN_DETAILS_SUCCESS";
export const RETURN_DETAILS_FAIL = "RETURN_DETAILS_FAIL";
export const RETURN_DETAILS_RESET = "RETURN_DETAILS_RESET";

export const RETURN_CANCEL_REQUEST = "RETURN_CANCEL_REQUEST";
export const RETURN_CANCEL_SUCCESS = "RETURN_CANCEL_SUCCESS";
export const RETURN_CANCEL_FAIL = "RETURN_CANCEL_FAIL";
export const RETURN_CANCEL_RESET = "RETURN_CANCEL_RESET";

export const RETURN_RESET_CURRENT = "RETURN_RESET_CURRENT";
export const RETURN_RESET_ERROR = "RETURN_RESET_ERROR";
export const RETURN_RESET_META = "RETURN_RESET_META";
export const RETURN_RESET_STATE = "RETURN_RESET_STATE";